export default __webpack_public_path__ + "static/media/mh-4.37d631e1.png";